import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllMunicipalities() {
  return get(`${apiHost}/api/admin/municipalities`);
}
